<template>
  <v-app :class="theme" style="margin-top:2rem">
    <v-overlay :value="loading" z-index="1000">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
    <mheader></mheader>
    <v-main class="pt-20 main">
      <v-container :fluid="true" class="pm-frame pa-0 pt-0">
        <router-view></router-view>
      </v-container>
    </v-main>
    <mfooter class="d-none d-md-block"></mfooter>
    <!-- <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn v-on:click="redirectToWa" fab large v-bind="attrs" v-on="on" bottom left
            style="position: fixed; bottom: 20px; right: 20px; z-index: 10; "
            class="rounded-lg bg-gradient d-none d-md-block">
            <v-avatar class="white mr-1">
              <v-icon>mdi-headset</v-icon>
            </v-avatar>
          </v-btn>
        </v-fab-transition>
      </template>
      <span>Bantuan Admin</span>
    </v-tooltip> -->

    <mnav></mnav>
  </v-app>
</template>

<script>
import mheader from "@/components/layout/store/Header";
import mfooter from "@/components/layout/store/Footer";
import { mapState } from "vuex";
import BottomNavVue from "./BottomNav.vue";
import Cookies from 'js-cookie'
import theme from  "@/plugins/theme.js"
export default {
  components: {
    mheader,
    mfooter,
    mnav: BottomNavVue,
  },
  computed: {
    theme(){
      const themeName = process.env.VUE_APP_THEME
      let key = Object.keys(theme).indexOf(themeName)
      return key > -1 ? themeName : 'default' 
    },
    ...mapState(["loading"]),
  },
  mounted() {
    const theme = Cookies.get("theme") || "light"; 
    this.$vuetify.theme.dark = theme === "dark";
  },
  methods: {
    redirectToWa() {
      return window.location.href = 'https://wa.me/' + process.env.VUE_APP_CS_NUMBER;
    }
  },
};
</script>
 